import curry from 'shadow-fns/src/curry'
import type from 'shadow-fns/src/type'

const isType = curry((str, val) => type(val) === str)
export default isType
